"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Title = exports.Root = exports.BreadcrumbsWrapper = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        minHeight: 205,
        backgroundColor: '#bcc5ba',
        [theme.breakpoints.up(768)]: {
            minHeight: 348
        }
    };
});
const BreadcrumbsWrapper = exports.BreadcrumbsWrapper = (0, _mui.styled)('div')({
    position: 'absolute',
    width: '100%'
});
const Title = exports.Title = (0, _mui.styled)('h1', {
    shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})((param)=>{
    let { isDefault, theme } = param;
    return {
        margin: 0,
        padding: theme.spacing(13, 3, 6, 3),
        color: theme.palette.common.white,
        fontSize: '1.8rem',
        fontWeight: theme.typography.fontWeightBold,
        textAlign: 'center',
        [theme.breakpoints.up(768)]: {
            padding: theme.spacing(23, 38, 9, 38),
            fontSize: '4.5rem'
        },
        ...isDefault && {
            padding: theme.spacing(6, 3),
            fontSize: '3.5rem',
            [theme.breakpoints.up(768)]: {
                padding: theme.spacing(23, 38, 9, 38)
            }
        }
    };
});
